module.exports = __webpack_public_path__ + "img/respiratory-therapy.3955bfb7.png";